export default {
  state: {
    personalInfo: {
      name: "",
      fatherName: "",
      grandFatherName: "",
      alternativeName: "",
      alternativeFatherName: "",
      alternativeGrandFatherName: "",
      gender: "",
      dateOfBirth: "",
      placeOfBirth: "",
      nationality: "",
      userTypeId: "",
      maritalStatusId: "",
      photo: "",
      woredaId: "",
      nationalityId: "",
    },
    maritalStatus: "",
    nationality: "",
    address: {
      kebele: "",
      houseNumber: "",
      residence: "",
      poBox: "",
    },
  },
};
